import { useMemo, useState } from 'react';
import { CardCreateIcon, TopUpIcon } from '../../../assets/icons/icons';
import './TransactionIcon.css';

const loadedLogoUrls = new Set();
const failedLogoUrls = new Set();

const RefundIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      d="M18.364 5.636a9 9 0 0 0-12.392-.32l-.336.32-.033.034-1.587 1.745V6a1 1 0 0 0-2 0v4a1 1 0 0 0 1 1H7a1 1 0 0 0 0-2H5.277l1.795-1.972a7 7 0 1 1-1.563 7.598 1 1 0 0 0-1.855.748 9 9 0 1 0 14.71-9.738M13 9a1 1 0 1 0-2 0v4a1 1 0 0 0 .553.895l3 1.5a1 1 0 0 0 .894-1.79L13 12.382z"
    />
  </svg>
);

const PaymentCanceledIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      d="M20 12a8 8 0 1 0-16 0 8 8 0 0 0 16 0m-5.707-3.707a1 1 0 1 1 1.414 1.414L13.414 12l2.293 2.293a1 1 0 1 1-1.414 1.414L12 13.414l-2.293 2.293a1 1 0 1 1-1.414-1.414L10.586 12 8.293 9.707a1 1 0 1 1 1.414-1.414L12 10.586zM22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10"
    />
  </svg>
);

const CashIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7.945 4.25h5.11c1.367 0 2.47 0 3.337.117.9.12 1.658.38 2.26.981.554.555.817 1.242.95 2.05.809.132 1.495.396 2.05.95.602.602.86 1.36.982 2.26.116.867.116 1.97.116 3.337v.11c0 1.367 0 2.47-.116 3.337-.121.9-.38 1.658-.982 2.26s-1.36.86-2.26.982c-.867.116-1.97.116-3.337.116h-5.11c-1.367 0-2.47 0-3.336-.116-.9-.122-1.658-.38-2.26-.982-.555-.555-.818-1.242-.95-2.05-.81-.133-1.496-.396-2.05-.95-.603-.602-.861-1.36-.982-2.26-.117-.867-.117-1.97-.117-3.337v-.11c0-1.367 0-2.47.117-3.337.12-.9.38-1.658.981-2.26.602-.602 1.36-.86 2.26-.981.867-.117 1.97-.117 3.337-.117m-1.99 13.482c.106.402.255.66.454.859.277.277.666.457 1.4.556.755.102 1.756.103 3.191.103h5c1.436 0 2.437-.002 3.192-.103.734-.099 1.122-.28 1.4-.556.276-.277.457-.665.555-1.4.102-.754.103-1.755.103-3.19s-.001-2.437-.103-3.193c-.098-.734-.279-1.122-.556-1.399-.2-.2-.456-.349-.86-.454.019.59.019 1.251.019 1.99v.11c0 1.367 0 2.47-.116 3.337-.122.9-.38 1.658-.982 2.26s-1.36.86-2.26.982c-.867.116-1.97.116-3.337.116h-5.11c-.739 0-1.4 0-1.99-.018M4.809 5.853c-.734.099-1.122.28-1.399.556-.277.277-.457.665-.556 1.4-.101.754-.103 1.756-.103 3.191s.002 2.437.103 3.192c.099.734.28 1.122.556 1.399.277.277.665.457 1.4.556.754.101 1.756.103 3.191.103h5c1.435 0 2.437-.002 3.192-.103.734-.099 1.122-.28 1.399-.556.277-.277.457-.665.556-1.4.101-.755.103-1.756.103-3.191s-.002-2.437-.103-3.192c-.099-.734-.28-1.122-.556-1.399-.277-.277-.665-.457-1.4-.556-.754-.101-1.756-.103-3.191-.103H8c-1.435 0-2.437.002-3.192.103M10.5 9.25a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5M7.25 11a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0M5 8.25a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0V9A.75.75 0 0 1 5 8.25m11 0a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0V9a.75.75 0 0 1 .75-.75"
      clipRule="evenodd"
    />
  </svg>
);

function getReadableColor(background) {
  const hex = String(background || '').trim().replace('#', '');

  if (!/^[0-9a-f]{6}$/i.test(hex)) {
    return '';
  }

  const red = Number.parseInt(hex.slice(0, 2), 16);
  const green = Number.parseInt(hex.slice(2, 4), 16);
  const blue = Number.parseInt(hex.slice(4, 6), 16);
  const luminance = (red * 299 + green * 587 + blue * 114) / 1000;

  return luminance > 150 ? '#111111' : '#ffffff';
}

function getResolvedIconVariant(transaction) {
  const iconVariant = transaction?.iconVariant || 'brand';
  const operationType = String(
    transaction?.operationType
    || transaction?.raw?.type
    || transaction?.type
    || ''
  ).trim().toLowerCase();

  if (iconVariant === 'payment-canceled' || operationType === 'payment_canceled') {
    return 'payment-canceled';
  }

  if (iconVariant === 'cash-withdrawal' || operationType === 'payment_withdrawal') {
    return 'cash-withdrawal';
  }

  if (iconVariant === 'refund' || operationType.includes('refund')) {
    return 'refund';
  }

  if (
    iconVariant === 'card-issue'
    || operationType === 'card_create'
    || operationType === 'create_card'
  ) {
    return 'card-issue';
  }

  if (
    iconVariant === 'deposit'
    || transaction?.category === 'topUp'
    || operationType.includes('deposit')
    || operationType.includes('top_up')
    || operationType.includes('topup')
  ) {
    return 'deposit';
  }

  return iconVariant;
}

function TransactionLogo({ src }) {
  const [status, setStatus] = useState(() => {
    if (loadedLogoUrls.has(src)) return 'loaded';
    if (failedLogoUrls.has(src)) return 'failed';
    return 'loading';
  });

  if (status === 'failed') {
    return null;
  }

  return (
    <img
      className={
        status === 'loaded'
          ? 'transaction-icon__image transaction-icon__image--loaded'
          : 'transaction-icon__image'
      }
      src={src}
      alt=""
      onLoad={() => {
        failedLogoUrls.delete(src);
        loadedLogoUrls.add(src);
        setStatus('loaded');
      }}
      onError={() => {
        loadedLogoUrls.delete(src);
        failedLogoUrls.add(src);
        setStatus('failed');
      }}
    />
  );
}

function TransactionIcon({ transaction, className = '' }) {
  const iconVariant = getResolvedIconVariant(transaction);
  const isDepositIcon = iconVariant === 'deposit';
  const isPaymentCanceledIcon = iconVariant === 'payment-canceled';
  const isRefundIcon = iconVariant === 'refund';
  const isCardIssueIcon = iconVariant === 'card-issue';
  const isCashWithdrawalIcon = iconVariant === 'cash-withdrawal';
  const iconUrl = transaction?.iconUrl || '';
  const shouldShowLogo = (
    !isDepositIcon
    && !isCardIssueIcon
    && !isCashWithdrawalIcon
    && iconUrl
  );

  const style = useMemo(() => {
    if (isDepositIcon || isCardIssueIcon || isCashWithdrawalIcon) {
      return {};
    }

    const background = transaction?.iconBackground;
    const color = getReadableColor(background);

    return {
      ...(background ? { '--transaction-icon-bg': background } : {}),
      ...(color ? { '--transaction-icon-color': color } : {}),
    };
  }, [
    isCardIssueIcon,
    isCashWithdrawalIcon,
    isDepositIcon,
    transaction?.iconBackground,
  ]);
  const rootClassName = [
    'transaction-icon',
    `transaction-icon--${iconVariant}`,
    className,
  ].filter(Boolean).join(' ');

  return (
    <span className={rootClassName} style={style} aria-hidden="true">
      {isDepositIcon && <TopUpIcon className="transaction-icon__svg" />}
      {isCardIssueIcon && <CardCreateIcon className="transaction-icon__svg" />}
      {isCashWithdrawalIcon && <CashIcon className="transaction-icon__svg" />}
      {!isDepositIcon && !isCardIssueIcon && !isCashWithdrawalIcon && (
        <span className="transaction-icon__letter">
          {transaction?.iconLetter || transaction?.icon || '?'}
        </span>
      )}
      {shouldShowLogo && (
        <TransactionLogo key={iconUrl} src={iconUrl} />
      )}
      {isPaymentCanceledIcon && (
        <span className="transaction-icon__status-badge transaction-icon__status-badge--canceled">
          <PaymentCanceledIcon />
        </span>
      )}
      {isRefundIcon && (
        <span className="transaction-icon__status-badge transaction-icon__status-badge--refund">
          <RefundIcon />
        </span>
      )}
    </span>
  );
}

export default TransactionIcon;
